import isNil from 'lodash/isNil';
import API from './../api';
import { newSeasonObject } from '../components/seasonality-template/constants';
import {
    SEASONALITY_TEMPLATE_TEMPLATE_LIST_ENDPOINT,
    SEASONALITY_TEMPLATE_TEMPLATE_SEASONS_YEAR_ENDPOINT,
    SEASONALITY_TEMPLATE_TEMPLATE_SETTINGS_LIST_ENDPOINT,
    SEASONALITY_TEMPLATE_TEMPLATE_SETTINGS_DETAIL_ENDPOINT,
    SEASONALITY_TEMPLATE_TEMPLATE_DATA_ENDPOINT,
    SEASONALITY_TEMPLATE_DEFAULT_TEMPLATE_SETTINGS_SAVE_ENDPOINT,
} from '../endpoints';

export default {
    namespaced: true,

    state() {
        return {
            busy: false,
            currentYear: null,
            selectedTemplate: null,
            initialTemplate: null,
            templates: [],
            defaultSeason: null,
            seasonsList: [],            
            templatesData: null,
            importTemplateFromPropertiesOptions: [],
            properties: [],
            newSeasonObject: newSeasonObject,
            lastObject: null,
        };
    },

    getters: {
        busy: state => state.busy,
        currentYear: state => state.currentYear,
        templates: state => state.templates,
        defaultSeason: state => state.defaultSeason,
        selectedTemplate: state => state.selectedTemplate,
        seasonsList: state => state.seasonsList,
        properties: state => state.properties,
        importTemplateFromPropertiesOptions: state => state.importTemplateFromPropertiesOptions,
        templatesData: state => state.templatesData,
        newSeasonObject: state => newSeasonObject,
        lastObject: state => state.lastObject,
    },

    mutations: {
        setBusy(state, value) {
            state.busy = value;
        },
        setCurrentYear(state, value) {
            state.currentYear = value;
        },
        setLastObject(state, value) {
            state.lastObject = value;
        },        
        setSelectedTemplate(state, value) {
            const oldValue = state.selectedTemplate;
            state.selectedTemplate = value;            
            if (!isNil(value) && !isNil(state.currentYear) && (isNil(oldValue) || value.id !== oldValue.id)) {
                this.dispatch('seasonality/fetchSeasonsList');
            }
        },
        setInitialTemplate(state, value) {
            state.initialTemplate = value;
        },                
        gotTemplates(state, {response, setTemplate}) {
            state.templates = response.data;
            if (setTemplate) {
                var template = null;
                if (isNil(state.selectedTemplate)) {
                    if (isNil(state.initialTemplate)) {
                        template = state.templates[0];
                    }
                    else {
                        template = state.templates.find(t => t.id === state.initialTemplate);
                        if (!template) {
                            template = state.templates[0];
                        }
                    }
                }
                else {
                    template = state.templates.find(t => t.id === state.selectedTemplate.id);
                }
                this.commit('seasonality/setSelectedTemplate', template);
            }
        },
        gotSeasonsList(state, response) {
            state.seasonsList = response.data;
            state.defaultSeason = state.seasonsList[0];
        },
                
        gotPropertyTemplateSettings(state, response) {
            state.properties = response.data.map((property, index) => {
                return {
                    ...property,
                    order: index + 1,
                    seasonality_template: property.template.name,
                    seasonality_template_selected: property.template.id
                };
            });
            state.importTemplateFromPropertiesOptions = response.data.map(property => ({
                ...property,
                value: {
                    id: property.id,
                    property_id: property.property_id,
                },
            }));
        },
        gotFetchTemplatesData(state, response) {
            state.templatesData = response.data;
            if (isNil(state.currentYear)) {
                state.currentYear = state.templatesData.current_year;
            }
        },
        savedPropertyTemplateSettings(state, response) {
        },
        updatedSettings(state, response) {
            state.templatesData.default_template_settings = response.data;
        },
    },

    actions: {
        async fetchTemplates({ commit }, setTemplate) {
            const response = await API.get(SEASONALITY_TEMPLATE_TEMPLATE_LIST_ENDPOINT())
            commit('gotTemplates', { response , setTemplate });
        },
        
        async fetchSeasonsList({ commit, state }) {
            commit('gotSeasonsList', await API.get(SEASONALITY_TEMPLATE_TEMPLATE_SEASONS_YEAR_ENDPOINT(state.selectedTemplate.id, state.currentYear)));
        },
        
        async fetchPropertyTemplateSettings({ commit, state }) {
            commit('gotPropertyTemplateSettings', await API.get(SEASONALITY_TEMPLATE_TEMPLATE_SETTINGS_LIST_ENDPOINT()));
        },

        async fetchTemplatesData({ commit, state }) {
            commit('gotFetchTemplatesData', await API.get(SEASONALITY_TEMPLATE_TEMPLATE_DATA_ENDPOINT()));
        },
        
        async savePropertyTemplateSettings({ commit }, data) {
            const payload = {
                template: data.seasonality_template_selected === -1 ? null : data.seasonality_template_selected,
                daily_rate: data.daily_rate,
                monthly_rate: data.monthly_rate,
                weekly_rate: data.weekly_rate,
                weekend_rate: data.weekend_rate,
            };
        
            commit('savedPropertyTemplateSettings', await API.patch(SEASONALITY_TEMPLATE_TEMPLATE_SETTINGS_DETAIL_ENDPOINT(data.id), payload));
        },        
        async updateSettings({ commit }, settings) {
            commit('updatedSettings', await API.post(SEASONALITY_TEMPLATE_DEFAULT_TEMPLATE_SETTINGS_SAVE_ENDPOINT(), settings));
        },
    },
};
